	import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FreeblocksdataService {

  constructor() { }
   getDataUniversal(){
	return [
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 6,
		"Controllore": "Carel",
		"art_comp": "XPC0490831",
		"tipoImpianto": "UNI S1 4G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 7,
		"Controllore": "Carel",
		"art_comp": "XPC0490831",
		"tipoImpianto": "UNI S1 4G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 4.5,
		"Controllore": "Carel",
		"art_comp": "XPC0490831",
		"tipoImpianto": "UNI S1 4G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 5.5,
		"Controllore": "Carel",
		"art_comp": "XPC0490831",
		"tipoImpianto": "UNI S1 4G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 10,
		"Controllore": "Carel",
		"art_comp": "XPC0490832",
		"tipoImpianto": "UNI S1 6G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 12,
		"Controllore": "Carel",
		"art_comp": "XPC0490832",
		"tipoImpianto": "UNI S1 6G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 6,
		"Controllore": "Carel",
		"art_comp": "XPC0490832",
		"tipoImpianto": "UNI S1 6G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 7,
		"Controllore": "Carel",
		"art_comp": "XPC0490832",
		"tipoImpianto": "UNI S1 6G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 16,
		"Controllore": "Carel",
		"art_comp": "XPC0490833",
		"tipoImpianto": "UNI S1 9G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 19,
		"Controllore": "Carel",
		"art_comp": "XPC0490833",
		"tipoImpianto": "UNI S1 9G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 9,
		"Controllore": "Carel",
		"art_comp": "XPC0490833",
		"tipoImpianto": "UNI S1 9G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 11,
		"Controllore": "Carel",
		"art_comp": "XPC0490833",
		"tipoImpianto": "UNI S1 9G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 24,
		"Controllore": "Carel",
		"art_comp": "XPC0490834",
		"tipoImpianto": "UNI S1 13G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 28,
		"Controllore": "Carel",
		"art_comp": "XPC0490834",
		"tipoImpianto": "UNI S1 13G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 14,
		"Controllore": "Carel",
		"art_comp": "XPC0490834",
		"tipoImpianto": "UNI S1 13G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 20,
		"Controllore": "Carel",
		"art_comp": "XPC0490834",
		"tipoImpianto": "UNI S1 13G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 29,
		"Controllore": "Carel",
		"art_comp": "XPC0491031",
		"tipoImpianto": "UNI M2 22G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 34,
		"Controllore": "Carel",
		"art_comp": "XPC0491031",
		"tipoImpianto": "UNI M2 22G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 22,
		"Controllore": "Carel",
		"art_comp": "XPC0491031",
		"tipoImpianto": "UNI M2 22G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 26,
		"Controllore": "Carel",
		"art_comp": "XPC0491031",
		"tipoImpianto": "UNI M2 22G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 35,
		"Controllore": "Carel",
		"art_comp": "XPC0491032",
		"tipoImpianto": "UNI M2 25G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 42,
		"Controllore": "Carel",
		"art_comp": "XPC0491032",
		"tipoImpianto": "UNI M2 25G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 25,
		"Controllore": "Carel",
		"art_comp": "XPC0491032",
		"tipoImpianto": "UNI M2 25G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 30,
		"Controllore": "Carel",
		"art_comp": "XPC0491032",
		"tipoImpianto": "UNI M2 25G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 40,
		"Controllore": "Carel",
		"art_comp": "XPC0491231",
		"tipoImpianto": "UNI L2 30G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 48,
		"Controllore": "Carel",
		"art_comp": "XPC0491231",
		"tipoImpianto": "UNI L2 30G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 30,
		"Controllore": "Carel",
		"art_comp": "XPC0491231",
		"tipoImpianto": "UNI L2 30G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 36,
		"Controllore": "Carel",
		"art_comp": "XPC0491231",
		"tipoImpianto": "UNI L2 30G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 32,
		"Volume": 52,
		"Controllore": "Carel",
		"art_comp": "XPC0491232",
		"tipoImpianto": "UNI L2 39G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 62,
		"Controllore": "Carel",
		"art_comp": "XPC0491232",
		"tipoImpianto": "UNI L2 39G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "0/+2",
		"IdTemperaturaEsterna": 43,
		"Volume": 40,
		"Controllore": "Carel",
		"art_comp": "XPC0491232",
		"tipoImpianto": "UNI L2 39G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "+6/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 48,
		"Controllore": "Carel",
		"art_comp": "XPC0491232",
		"tipoImpianto": "UNI L2 39G",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 4.5,
		"Controllore": "Carel",
		"art_comp": "XPC0490931",
		"tipoImpianto": "UNI S1 3N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 32,
		"Volume": 3,
		"Controllore": "Carel",
		"art_comp": "XPC0490931",
		"tipoImpianto": "UNI S1 3N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 3,
		"Controllore": "Carel",
		"art_comp": "XPC0490931",
		"tipoImpianto": "UNI S1 3N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 43,
		"Volume": 2,
		"Controllore": "Carel",
		"art_comp": "XPC0490931",
		"tipoImpianto": "UNI S1 3N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 6,
		"Controllore": "Carel",
		"art_comp": "XPC0490932",
		"tipoImpianto": "UNI S1 5N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 32,
		"Volume": 4,
		"Controllore": "Carel",
		"art_comp": "XPC0490932",
		"tipoImpianto": "UNI S1 5N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 4,
		"Controllore": "Carel",
		"art_comp": "XPC0490932",
		"tipoImpianto": "UNI S1 5N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 43,
		"Volume": 3,
		"Controllore": "Carel",
		"art_comp": "XPC0490932",
		"tipoImpianto": "UNI S1 5N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 10,
		"Controllore": "Carel",
		"art_comp": "XPC0490933",
		"tipoImpianto": "UNI S1 7N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 32,
		"Volume": 7,
		"Controllore": "Carel",
		"art_comp": "XPC0490933",
		"tipoImpianto": "UNI S1 7N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 7,
		"Controllore": "Carel",
		"art_comp": "XPC0490933",
		"tipoImpianto": "UNI S1 7N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 43,
		"Volume": 5,
		"Controllore": "Carel",
		"art_comp": "XPC0490933",
		"tipoImpianto": "UNI S1 7N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945100",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 19,
		"Controllore": "Carel",
		"art_comp": "XPC0491131",
		"tipoImpianto": "UNI M2 12N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 32,
		"Volume": 15,
		"Controllore": "Carel",
		"art_comp": "XPC0491131",
		"tipoImpianto": "UNI M2 12N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 12,
		"Controllore": "Carel",
		"art_comp": "XPC0491131",
		"tipoImpianto": "UNI M2 12N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 43,
		"Volume": 8,
		"Controllore": "Carel",
		"art_comp": "XPC0491131",
		"tipoImpianto": "UNI M2 12N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 27,
		"Controllore": "Carel",
		"art_comp": "XPC0491132",
		"tipoImpianto": "UNI M2 14N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 32,
		"Volume": 19,
		"Controllore": "Carel",
		"art_comp": "XPC0491132",
		"tipoImpianto": "UNI M2 14N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 16,
		"Controllore": "Carel",
		"art_comp": "XPC0491132",
		"tipoImpianto": "UNI M2 14N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 43,
		"Volume": 10,
		"Controllore": "Carel",
		"art_comp": "XPC0491132",
		"tipoImpianto": "UNI M2 14N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 38,
		"Controllore": "Carel",
		"art_comp": "XPC0491331",
		"tipoImpianto": "UNI L2 25N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 32,
		"Volume": 28,
		"Controllore": "Carel",
		"art_comp": "XPC0491331",
		"tipoImpianto": "UNI L2 25N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 25,
		"Controllore": "Carel",
		"art_comp": "XPC0491331",
		"tipoImpianto": "UNI L2 25N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	},
	{
		"Spessore_pannello": null,
		"Dimensione_pannello": null,
		"IdTemperaturaInterna": "-23/-25",
		"IdTemperaturaEsterna": 43,
		"Volume": 18,
		"Controllore": "Carel",
		"art_comp": "XPC0491331",
		"tipoImpianto": "UNI L2 25N",
		"sopra_porta": "NO",
		stock: "NO",
		accessorio_resistenza_carter: "M1945900",
		accessorio_bacinella_acqua: "MS093095"
	}	
	]	
   }
   getData() {
        return [
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "40x80",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 6.8,
		"Controllore": "Carel",
		"art_comp": "XC0449931",
		"tipoImpianto": "FB3G",
		"sopra_porta": "NO",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "40x80",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 9,
		"Controllore": "Carel",
		"art_comp": "XC0449931",
		"tipoImpianto": "FB3G",
		"sopra_porta": "NO",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "40x80",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 6,
		"Controllore": "Carel",
		"art_comp": "XC0450031",
		"tipoImpianto": "FB3N",
		"sopra_porta": "NO",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "40x80",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 7,
		"Controllore": "Carel",
		"art_comp": "XC0450031",
		"tipoImpianto": "FB3N",
		"sopra_porta": "NO",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
	
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 9,
		"Controllore": "Carel",
		"art_comp": "XC0449932",
		"tipoImpianto": "FB7G",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 6.8,
		"Controllore": "Carel",
		"art_comp": "XC0449932",
		"tipoImpianto": "FB7G",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 14,
		"Controllore": "Carel",
		"art_comp": "XC0449933",
		"tipoImpianto": "FB13G",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 9.4,
		"Controllore": "Carel",
		"art_comp": "XC0449933",
		"tipoImpianto": "FB13G",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 32,
		"Volume": 17,
		"Controllore": "Carel",
		"art_comp": "XC0449934",
		"tipoImpianto": "FB16G",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945900",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 6,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-2/+8",
		"IdTemperaturaEsterna": 43,
		"Volume": 13,
		"Controllore": "Carel",
		"art_comp": "XC0449934",
		"tipoImpianto": "FB16G",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945900",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 6,
		"Controllore": "Carel",
		"art_comp": "XC0450032",
		"tipoImpianto": "FB6N",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 7,
		"Controllore": "Carel",
		"art_comp": "XC0450032",
		"tipoImpianto": "FB6N",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945100",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 12,
		"Controllore": "Carel",
		"art_comp": "XC0450033",
		"tipoImpianto": "FB13N",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945900",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 10,
		"Controllore": "Carel",
		"art_comp": "XC0450033",
		"tipoImpianto": "FB13N",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945900",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 32,
		"Volume": 19,
		"Controllore": "Carel",
		"art_comp": "XC0450034",
		"tipoImpianto": "FB20N",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945900",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
		{
		"Spessore_pannello": 10,
		"Dimensione_pannello": "80x40",
		"IdTemperaturaInterna": "-18/-20",
		"IdTemperaturaEsterna": 43,
		"Volume": 16,
		"Controllore": "Carel",
		"art_comp": "XC0450034",
		"tipoImpianto": "FB20N",
		"sopra_porta": "SI",
		"stock": "SI",
		accessorio_resistenza_carter: "M1945900",
		"accessorio_bus_adapter": "MS017734",
		"accessorio_bacinella_acqua": "MS093095"
		},
        {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Carel",
				"art_comp": "XC0460031",
				"tipoImpianto": "FB3G",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Carel",
				"art_comp": "XC0460031",
				"tipoImpianto": "FB3G",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Eliwell",
				"art_comp": "XMS072420",
				"tipoImpianto": "FB3G",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Eliwell",
				"art_comp": "XMS072420",
				"tipoImpianto": "FB3G",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Carel",
				"art_comp": "XC0460131",
				"tipoImpianto": "FB3G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Carel",
				"art_comp": "XC0460131",
				"tipoImpianto": "FB3G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 6,
				"Controllore": "Carel",
				"art_comp": "XC0460231",
				"tipoImpianto": "FB3N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 7,
				"Controllore": "Carel",
				"art_comp": "XC0460231",
				"tipoImpianto": "FB3N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Eliwell",
				"art_comp": "XMS072430",
				"tipoImpianto": "FB3G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Eliwell",
				"art_comp": "XMS072430",
				"tipoImpianto": "FB3G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 6,
				"Controllore": "Eliwell",
				"art_comp": "XMS072440",
				"tipoImpianto": "FB3N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "40x80",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 7,
				"Controllore": "Eliwell",
				"art_comp": "XMS072440",
				"tipoImpianto": "FB3N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Carel",
				"art_comp": "XC0460032",
				"tipoImpianto": "FB7G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Carel",
				"art_comp": "XC0460032",
				"tipoImpianto": "FB7G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 14,
				"Controllore": "Carel",
				"art_comp": "XC0460033",
				"tipoImpianto": "FB13G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 9.4,
				"Controllore": "Carel",
				"art_comp": "XC0460033",
				"tipoImpianto": "FB13G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 17,
				"Controllore": "Carel",
				"art_comp": "XC0460034",
				"tipoImpianto": "FB16G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 13,
				"Controllore": "Carel",
				"art_comp": "XC0460034",
				"tipoImpianto": "FB16G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 17.8,
				"Controllore": "Carel",
				"art_comp": "XC0460035",
				"tipoImpianto": "FB20G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 23,
				"Controllore": "Carel",
				"art_comp": "XC0460035",
				"tipoImpianto": "FB20G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 23,
				"Controllore": "Carel",
				"art_comp": "XC0460036",
				"tipoImpianto": "FB26G",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 29,
				"Controllore": "Carel",
				"art_comp": "XC0460036",
				"tipoImpianto": "FB26G",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Eliwell",
				"art_comp": "XMS072421",
				"tipoImpianto": "FB7G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Eliwell",
				"art_comp": "XMS072421",
				"tipoImpianto": "FB7G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 14,
				"Controllore": "Eliwell",
				"art_comp": "XMS072422",
				"tipoImpianto": "FB13G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 9.4,
				"Controllore": "Eliwell",
				"art_comp": "XMS072422",
				"tipoImpianto": "FB13G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 17,
				"Controllore": "Eliwell",
				"art_comp": "XMS072423",
				"tipoImpianto": "FB16G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 13,
				"Controllore": "Eliwell",
				"art_comp": "XMS072423",
				"tipoImpianto": "FB16G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 17.8,
				"Controllore": "Eliwell",
				"art_comp": "XMS072424",
				"tipoImpianto": "FB20G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 23,
				"Controllore": "Eliwell",
				"art_comp": "XMS072424",
				"tipoImpianto": "FB20G",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 23,
				"Controllore": "Eliwell",
				"art_comp": "XMS072425",
				"tipoImpianto": "FB26G",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 6,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 29,
				"Controllore": "Eliwell",
				"art_comp": "XMS072425",
				"tipoImpianto": "FB26G",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Carel",
				"art_comp": "XC0460132",
				"tipoImpianto": "FB7G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Carel",
				"art_comp": "XC0460132",
				"tipoImpianto": "FB7G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 14,
				"Controllore": "Carel",
				"art_comp": "XC0460133",
				"tipoImpianto": "FB13G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 9.4,
				"Controllore": "Carel",
				"art_comp": "XC0460133",
				"tipoImpianto": "FB13G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 17,
				"Controllore": "Carel",
				"art_comp": "XC0460134",
				"tipoImpianto": "FB16G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 13,
				"Controllore": "Carel",
				"art_comp": "XC0460134",
				"tipoImpianto": "FB16G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 17.8,
				"Controllore": "Carel",
				"art_comp": "XC0460135",
				"tipoImpianto": "FB20G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 23,
				"Controllore": "Carel",
				"art_comp": "XC0460135",
				"tipoImpianto": "FB20G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 23,
				"Controllore": "Carel",
				"art_comp": "XC0460136",
				"tipoImpianto": "FB26G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 29,
				"Controllore": "Carel",
				"art_comp": "XC0460136",
				"tipoImpianto": "FB26G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 6,
				"Controllore": "Carel",
				"art_comp": "XC0460232",
				"tipoImpianto": "FB6N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 7,
				"Controllore": "Carel",
				"art_comp": "XC0460232",
				"tipoImpianto": "FB6N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 12,
				"Controllore": "Carel",
				"art_comp": "XC0460233",
				"tipoImpianto": "FB13N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 10,
				"Controllore": "Carel",
				"art_comp": "XC0460233",
				"tipoImpianto": "FB13N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 19,
				"Controllore": "Carel",
				"art_comp": "XC0460234",
				"tipoImpianto": "FB20N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 16,
				"Controllore": "Carel",
				"art_comp": "XC0460234",
				"tipoImpianto": "FB20N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 27,
				"Controllore": "Carel",
				"art_comp": "XC0460235",
				"tipoImpianto": "FB28N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 24,
				"Controllore": "Carel",
				"art_comp": "XC0460235",
				"tipoImpianto": "FB28N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 9,
				"Controllore": "Eliwell",
				"art_comp": "XMS072431",
				"tipoImpianto": "FB7G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 6.8,
				"Controllore": "Eliwell",
				"art_comp": "XMS072431",
				"tipoImpianto": "FB7G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 14,
				"Controllore": "Eliwell",
				"art_comp": "XMS072432",
				"tipoImpianto": "FB13G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 9.4,
				"Controllore": "Eliwell",
				"art_comp": "XMS072432",
				"tipoImpianto": "FB13G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 17,
				"Controllore": "Eliwell",
				"art_comp": "XMS072433",
				"tipoImpianto": "FB16G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 13,
				"Controllore": "Eliwell",
				"art_comp": "XMS072433",
				"tipoImpianto": "FB16G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 17.8,
				"Controllore": "Eliwell",
				"art_comp": "XMS072434",
				"tipoImpianto": "FB20G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 23,
				"Controllore": "Eliwell",
				"art_comp": "XMS072434",
				"tipoImpianto": "FB20G/10",
				"sopra_porta": "SI",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 43,
				"Volume": 23,
				"Controllore": "Eliwell",
				"art_comp": "XMS072435",
				"tipoImpianto": "FB26G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-2/+8",
				"IdTemperaturaEsterna": 32,
				"Volume": 29,
				"Controllore": "Eliwell",
				"art_comp": "XMS072435",
				"tipoImpianto": "FB26G/10",
				"sopra_porta": "NO",
				"stock": "NO",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 6,
				"Controllore": "Eliwell",
				"art_comp": "XMS072441",
				"tipoImpianto": "FB6N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 7,
				"Controllore": "Eliwell",
				"art_comp": "XMS072441",
				"tipoImpianto": "FB6N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945100",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 12,
				"Controllore": "Eliwell",
				"art_comp": "XMS072442",
				"tipoImpianto": "FB13N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 10,
				"Controllore": "Eliwell",
				"art_comp": "XMS072442",
				"tipoImpianto": "FB13N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 19,
				"Controllore": "Eliwell",
				"art_comp": "XMS072443",
				"tipoImpianto": "FB20N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 16,
				"Controllore": "Eliwell",
				"art_comp": "XMS072443",
				"tipoImpianto": "FB20N",
				"sopra_porta": "SI",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 32,
				"Volume": 27,
				"Controllore": "Eliwell",
				"art_comp": "XMS072444",
				"tipoImpianto": "FB28N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  },
			  {
				"Spessore_pannello": 10,
				"Dimensione_pannello": "80x40",
				"IdTemperaturaInterna": "-18/-20",
				"IdTemperaturaEsterna": 43,
				"Volume": 24,
				"Controllore": "Eliwell",
				"art_comp": "XMS072444",
				"tipoImpianto": "FB28N",
				"sopra_porta": "NO",
				"stock": "SI",
				accessorio_resistenza_carter: "M1945900",
				"accessorio_bus_adapter": "MS017734",
				"accessorio_bacinella_acqua": "MS093095"
			  }
			]
	}
}
